/**
 * Smart Header Scroll Behavior (Mobile Only - max 768px)
 * - Hides header when scrolling down
 * - Shows header when scrolling up 50px
 * - Returns to normal position when at top of page
 */

(function() {
  let lastScrollTop = 0;
  let scrollUpDistance = 0;
  let isHeaderHidden = false;
  let isHeaderFloating = false;
  const scrollThreshold = 50; // pixels to scroll up before showing header
  const mobileBreakpoint = 768; // only apply on mobile
  const headerSection = document.getElementById('shopify-section-header');
  
  if (!headerSection) return;

  function isMobile() {
    return window.innerWidth <= mobileBreakpoint;
  }

  function handleScroll() {
    // Only apply scroll behavior on mobile
    if (!isMobile()) {
      // Remove classes if we're on desktop
      headerSection.classList.remove('header--hidden', 'header--floating');
      isHeaderHidden = false;
      isHeaderFloating = false;
      scrollUpDistance = 0;
      return;
    }

    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    const scrollingDown = currentScroll > lastScrollTop;
    const isAtTop = currentScroll <= 10;

    // At top of page - reset to normal state
    if (isAtTop) {
      headerSection.classList.remove('header--hidden', 'header--floating');
      isHeaderHidden = false;
      isHeaderFloating = false;
      scrollUpDistance = 0;
    }
    // Scrolling down - hide header
    else if (scrollingDown && !isHeaderHidden) {
      headerSection.classList.add('header--hidden');
      headerSection.classList.remove('header--floating');
      isHeaderHidden = true;
      isHeaderFloating = false;
      scrollUpDistance = 0;
    }
    // Scrolling up - track distance
    else if (!scrollingDown && isHeaderHidden) {
      scrollUpDistance += lastScrollTop - currentScroll;
      
      // Show header as overlay after scrolling up threshold
      if (scrollUpDistance >= scrollThreshold) {
        headerSection.classList.remove('header--hidden');
        headerSection.classList.add('header--floating');
        isHeaderHidden = false;
        isHeaderFloating = true;
        scrollUpDistance = 0;
      }
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  // Use requestAnimationFrame for smooth performance
  let ticking = false;
  
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Reset on resize to handle orientation changes
  window.addEventListener('resize', function() {
    if (!isMobile()) {
      headerSection.classList.remove('header--hidden', 'header--floating');
      isHeaderHidden = false;
      isHeaderFloating = false;
      scrollUpDistance = 0;
    }
  });
})();
